export default "__VITE_ASSET__CaMKv8G3__"